import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Map } from 'core-js';
import { ToastrService } from 'ngx-toastr';
import { off } from 'process';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AdministracionObjetivos } from '../../models/administracion-objetivos';
import { AdministracionObjetivosService } from '../../services/administracion-objetivos.service';
import { GlobalUIUtilsService } from '../../services/global-ui-utils.service';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';

@Component({
  selector: 'app-administracion-objetivos',
  templateUrl: './administracion-objetivos.component.html',
  styleUrls: ['./administracion-objetivos.component.scss']
})
export class AdministracionObjetivosComponent implements OnInit {

  form: FormGroup;
  filtroObjetivos: AdministracionObjetivos;
  oficinaFacturacionList: any;
  objetivo: AdministracionObjetivos;
  objetivosList: any;
  data: any;
  errorMessage: string  = '';
  impObj: number;
  newObjetivosList: AdministracionObjetivos[];
  currentYear = new Date().getFullYear();
  message = this.translate.instant('comunes.toastr_guardado');
  total = 0;

  constructor(private _AdministracionObjetivosService: AdministracionObjetivosService, private _GlobalUIUtilsService: GlobalUIUtilsService, private translate: TranslateService)
  {
    console.log("constructor");
  }

  ngOnInit() {
    console.log("ngOnInit");
    this.createForm();
    this.getData();
  }

  getData() {
    console.log("getData");
    // Traemos la lista de las oficinas de facturación
    this._AdministracionObjetivosService.getOficinasFacturacion().subscribe(data => this.oficinaFacturacionList = data);
  }

  loadData() {
    // Cargamos la tabla con los objetivos
    console.log("loadData");
    this._AdministracionObjetivosService.getData(this.filtroObjetivos.year, this.filtroObjetivos.OfFactId).subscribe(data => { this.objetivosList = data })
    console.log(this.objetivosList);
  }

  createForm() {

    // Crea el formulario
    this.form = new FormGroup({
      ofFact: new FormControl('', Validators.required),
      year: new FormControl(this.currentYear, Validators.compose([
        Validators.pattern('^-?(0|[1-9]\\d*)?$'),
        Validators.required
      ]))
    })
  }

  onLoad() {
    if (!this.form.valid) {
      this.getFormValidationErrors();
      this.errorMessage = 'Por favor, complete todos los campos requeridos';
    } else {
      console.log("Load");
      this.filtroObjetivos = new AdministracionObjetivos();
      //traemos formulario para el filtro
      this.filtroObjetivos.OfFactId = this.form.get('ofFact').value;
      this.filtroObjetivos.year = this.form.get('year').value;
      this.loadData();
      console.log(this.objetivosList);
      console.log("Fin Cargar");
    }
    console.log(this.objetivosList);
   this.getTotal();
  }

  onChangeEvent(event, month) {

    for(let i = 0; i < this.objetivosList.length; i++) {
      if(this.objetivosList[i].month == month) {
        if(event == '') {
          event = 0;
        }
        this.objetivosList[i].importeObjetivo = event;
      }
    }
  }

  getTotal() {
    var total = 0;
    for(let i = 0; i < this.objetivosList.length; i++) {
      total += this.objetivosList[i].importeReal;
    }
    console.log(total);

    // this.objetivosList.forEach(x => total += x.importeObjetivo);
    // console.log(total);
  }


  submitChanges() {
    console.log("submitChanges")

    this.objetivosList.forEach(x => console.log(x))

    this._AdministracionObjetivosService.updateAll(this.objetivosList).subscribe(response => {
      console.log(response);
      this._GlobalUIUtilsService.success(this.message);
    },
    error => {
      console.log(error);
    });


  }

  getFormValidationErrors() {
    Object.keys(this.form.controls).forEach(key => {

    const controlErrors: ValidationErrors = this.form.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
          });
        }
      });
    }

}
